import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultBooleanField } from "helpers/row-logic-helper";

import {
  shouldShowPaymentDay
  , shouldShowPaymentDayAdjust
  , shouldShowCalculationDay
  , shouldShowCalculationDayAdjust
  , shouldShowRounding
  , shouldShowResetDay
  , shouldShowResetDayAdjust
  , shouldShowResetDayLookback
  , shouldShowLei
  , shouldShowCollateral
  , shouldShowGuaranty
  , shouldShowCollateralAssignment
  , shouldShowLegalOpinion
} from "./section-general-information-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  paymentDay: {
    isVisible: data => shouldShowPaymentDay(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Payment Dates",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "paymentDay"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  paymentDayAdjust: {
    isVisible: data => shouldShowPaymentDayAdjust(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Payment Adjustment",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "paymentDayAdjust.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  calculationDay: {
    isVisible: data => shouldShowCalculationDay(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Calculation Dates",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "calculationDay"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  calculationDayAdjust: {
    isVisible: data => shouldShowCalculationDayAdjust(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Calculation Adjustment",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "calculationDayAdjust.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  rounding: {
    isVisible: data => shouldShowRounding(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Calculation Rounding",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "rounding.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  resetDay: {
    isVisible: data => shouldShowResetDay(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reset Dates",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "resetDay"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  resetDayAdjust: {
    isVisible: data => shouldShowResetDayAdjust(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reset Adjustment",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "resetDayAdjust.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  resetDayLookback: {
    isVisible: data => shouldShowResetDayLookback(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Lookback Days",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "resetDayLookback"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  daycount: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Daycount Ratio",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "daycount.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  lei: {
    isVisible: data => shouldShowLei(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "LEI",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "lei"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  collateral: {
    isVisible: data => shouldShowCollateral(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Collateral",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "collateral.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  guaranty: {
    isVisible: data => shouldShowGuaranty(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Guaranty",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.BOOLEAN,
        map: data => defaultBooleanField(data, "guaranty"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  collateralAssignment: {
    isVisible: data => shouldShowCollateralAssignment(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Collateral Assignment",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.BOOLEAN,
        map: data => defaultField(data, "collateralAssignment"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  legalOpinion: {
    isVisible: data => shouldShowLegalOpinion(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Legal Opinion",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.BOOLEAN,
        map: data => defaultField(data, "legalOpinion"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  // NOTE: This does not map the the DB! This is based on if the loanId has a value or not!
  taggedTo: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Tagged to",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => {
          const value = defaultField(data, "loanId");

          return !value || value === "--" ? "Deal" : "Loan";
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  isLenderRequired: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Required Hedge",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.BOOLEAN,
        map: data => defaultBooleanField(data, "isLenderRequired"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
